import { Button, Icons } from '@commenda/kakashi';
import { useNotification } from '../hooks/useNotification';
import { copyToClipboard } from '@commenda/utils';
import { memo } from 'react';
import { JsonView } from 'react-json-view-lite';

const jsonViewerStyles = {
  container: 'json-viewer-container',
  basicChildStyle: 'json-viewer-basic-child',
  label: 'json-viewer-label',
  clickableLabel: 'json-viewer-clickable-label',
  nullValue: 'json-viewer-null',
  undefinedValue: 'json-viewer-undefined',
  numberValue: 'json-viewer-number',
  stringValue: 'json-viewer-string',
  booleanValue: 'json-viewer-boolean',
  otherValue: 'json-viewer-other',
  punctuation: 'json-viewer-punctuation',
  expandIcon: 'json-viewer-expand-icon',
  collapseIcon: 'json-viewer-collapse-icon',
  collapsedContent: 'json-viewer-collapsed-content',
  childFieldsContainer: 'json-viewer-child-fields',
  noQuotesForStringValues: false,
  quotesForFieldNames: false,
  ariaLables: {
    collapseJson: 'collapse JSON',
    expandJson: 'expand JSON',
  },
  stringifyStringValues: false,
};

export const JsonViewer = memo(
  ({
    data,
    shouldExpandNode = (level: number) => level < 1,
    clickToExpandNode = true,
  }: {
    data: object;
    shouldExpandNode?: (level: number) => boolean;
    clickToExpandNode?: boolean;
  }) => {
    const { setNotification } = useNotification();

    return (
      <div className="relative p-2">
        {data && (
          <Button
            onClick={() => {
              copyToClipboard(JSON.stringify(data));
              setNotification({
                show: true,
                title: 'Success',
                message: 'Copied successfully!',
                valid: true,
              });
            }}
            variant="secondary"
            className="rounded absolute right-4 top-4 border-none bg-bg-secondary hover:bg-bg-tertiary"
          >
            <Icons.Copy06 className="size-4" />
          </Button>
        )}
        <JsonView
          data={data || {}}
          style={jsonViewerStyles}
          shouldExpandNode={shouldExpandNode}
          clickToExpandNode={clickToExpandNode}
        />
      </div>
    );
  }
);
